import { useTranslation } from "react-migration/lib/i18n/useTranslation";
export const ImpersonationBanner = () => {
  const { t } = useTranslation();
  return (
    <div
      id="impersonation-banner"
      className="absolute bottom-0 left-0 w-full p-2 bg-warning-400 z-9999 text-warning-800"
      data-testid="overdue-invoice-banner"
    >
      <div className="flex items-center text-center">
        <div className="flex-1">
          <strong> {t("nav.you_are_running_in_impersonation_mode")} </strong>-{" "}
          {t("nav.logout_to_return_to_your_normal_account")}
        </div>
      </div>
    </div>
  );
};
